const normalizeExpirationRules = (outletProduct) => {
  const rules = outletProduct?.expirationRules

  return Array.isArray(rules) ? rules : []
}

const resolveOutletExpirationOption = (outletProduct, outletOptionId) => {
  if (outletOptionId == null || outletOptionId === '') {
    return null
  }

  const rules = normalizeExpirationRules(outletProduct)

  if (!rules.length) {
    return null
  }

  const byId = rules.find((rule) => rule?.id != null && String(rule.id) === String(outletOptionId))

  if (byId) {
    return byId
  }

  const index = Number(outletOptionId)

  if (Number.isInteger(index) && index >= 0 && index < rules.length) {
    return rules[index]
  }

  return null
}

export default resolveOutletExpirationOption
